import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

@Component({ name: "HomePageSearchBox" })
export default class HomePageSearchBox extends Vue {
    public searchtext: string = null;
    public suggestionListIndex: number = -1;
    public isLoading: boolean = false;
    public debounceTimeOut: any = null;

    get suggestions() {
        return this.$store.getters["searchStore/suggestions"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("searchtext")
    public async onSearchTextChange(newText) {
        this.debounceGetSuggestions(newText, 500);
    }

    public created() {
        const outsideClickListener = event => {
            if (!this.$el.contains(event.target)) {
                this.clear();
            }
        }

        document.addEventListener("click", outsideClickListener)
    }

    public debounceGetSuggestions(searchtext: any, delay: number) {
        let self = this;

        clearTimeout(this.debounceTimeOut);
        this.debounceTimeOut = setTimeout(async function (context) {
            if (searchtext != null && searchtext.length >= 3) {
                await self.getSuggestions();
            } else if (searchtext === null || searchtext.length === 0) {
                self.clear();
            }
        }, delay, this);
    }

    public async getSuggestions() {
        this.isLoading = true;
        let response = await this.$store.dispatch("searchStore/getSuggestions", { searchtext: this.searchtext });

        if (response.data) {
            this.$store.commit("searchStore/setSuggestions", response.data);
        }

        this.isLoading = false;
    }

    public moveUp() {
        if (this.suggestions.length !== 0 && this.suggestionListIndex > 0) {
            this.suggestionListIndex--;
        }
    }

    public moveDown() {
        if (this.suggestions.length !== 0 && this.suggestionListIndex < this.suggestions.length - 1) {
            this.suggestionListIndex++;
        }
    }

    public suggestionSelect(index: number) {
        if (index !== -1) {
            this.suggestionListIndex = index;
        }

        if (this.suggestions.length !== 0 && this.suggestionListIndex !== -1) {
            let selectedSuggestion = this.suggestions[this.suggestionListIndex];

            GTagHelper.sendEvent("view_search_results", "home_suggestion", "keyboard")

            window.location = selectedSuggestion.linkUrl;

            this.clear();
        } else {
            this.showAll();
        }
    }

    public clear() {
        this.$store.commit("searchStore/setSuggestions", []);
        this.suggestionListIndex = -1;
        this.searchtext = null;
    }

    public showAll() {
        GTagHelper.sendEvent("view_search_results", "home_result_list_all");
        (<any>window).location = this.routes.Search_List + "?searchtext=" + this.searchtext;
    }

    public setAnalytics(suggestion: any) {
        GTagHelper.sendEvent("view_search_results", "home_suggestion", "click")
    }
};